import { call, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import * as actionTypes from "../ActionTypes";

import {
  saveProgramLanguageMetaSuccess,
  saveProgramLanguageMetaFailure,
} from "./action.js";

import { saveProgramLanguageMeta } from "./programLanguage.js";

// ✅ Save Program Language Meta Saga
function* saveProgramLanguageMetaSaga(action) {
  try {

    const { apiPayloadRequest } = action.payload;

    // Validate required fields
    if (!apiPayloadRequest?._id || !apiPayloadRequest?.language_code) {
      throw new Error("Missing required fields (_id or language_code).");
    }

    const response = yield call(saveProgramLanguageMeta, apiPayloadRequest);

    if (response?.type === 1) {
      yield put(saveProgramLanguageMetaSuccess(response));
      toast.success("Program Language Meta saved successfully!");
      if (action.callback) action.callback({ type: 1, data: response });
    } else {
      throw new Error(response?.error || "Failed to save Program Language Meta.");
    }
  } catch (error) {
    yield put(saveProgramLanguageMetaFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// ✅ Watcher
export default function* programLanguageMetaWatcherSaga() {
  yield takeLatest(
    actionTypes.SAVE_PROGRAM_LANGUAGE_META_REQUEST,
    saveProgramLanguageMetaSaga
  );
}
